export default "__VITE_ASSET__BheknWRd__"